export function getUniqueId(): string {
  return '_' + globalThis.crypto.randomUUID().replace(/-/g, '').substring(0, 7);
}
